import ajax from '../util/ajax';
import { getUrl, supports } from '../util/context';

const Api = () => {

    const addPlayersToRoster = options => {

        const data = {
            gameId:  options.gameId,
            players: JSON.stringify( options.players ),
            teamId:  options.teamId,
            token:   options.token
        };

        if ( supports( options.context, 'teamOfficials' ) ) {

            data.teamOfficials = JSON.stringify( options.teamOfficials );

        }

        return ajax(
            getUrl( options.context, 'AddPlayersToRoster' ),
            data,
            {
                method: 'POST'
            }
        );

    }

    const confirmGameReportReferee = options => {

        return ajax(
            getUrl( options.context, 'SaveGameReportReferee' ),
            {
                gameId:     options.gameId,
                reportJson: JSON.stringify( options.gameReportReferee ),
                token:      options.token,
                doConfirm:  1
            },
            {
                method: 'POST'
            }
        );

    }

    const confirmRosterPlayers = options => {

        return ajax(
            getUrl( options.context, 'ConfirmPlayers' ),
            {
                gameId:  options.gameId,
                players: JSON.stringify( options.players ),
                token:   options.token
            },
            {
                method: 'POST'
            }
        );

    }

    const editRosterPlayer = options => {

        const data = {
            gameId:     options.gameId,
            lineupData: JSON.stringify( options.player.lineupData ),
            playerId:   options.player.id,
            teamId:     options.teamId,
            token:      options.token
        };

        if ( supports( options.context, 'teamOfficials' ) ) {

            data.isTeamOfficial = options.player.isTeamOfficial;

        }

        return ajax(
            getUrl( options.context, 'EditPlayerInRoster' ),
            data,
            {
                method: 'POST'
            }
        );

    };

    const editRosterPlayers = options => {

        const data = {
            gameId:  options.gameId,
            players: JSON.stringify( options.players ),
            teamId:  options.teamId,
            token:   options.token
        };

        return ajax(
            getUrl( options.context, 'EditPlayersInRoster' ),
            data,
            {
                method: 'POST'
            }
        );

    };

    const getEligiblePlayers = options => {

        return ajax(
            getUrl( options.context, 'EligiblePlayers' ),
            {
                gameId: options.gameId,
                teamId: options.teamId,
                token:  options.token
            }
        );

    };

    const getEligibleTeamOfficials = options => {

        return ajax(
            getUrl( options.context, 'EligibleTeamOfficials' ),
            {
                gameId: options.gameId,
                teamId: options.teamId,
                token:  options.token
            }
        );

    };

    const getExtendedEligiblePlayers = options => {

        return ajax(
            getUrl( options.context, 'ExtendedEligiblePlayers' ),
            {
                gameId: options.gameId,
                teamId: options.teamId,
                token:  options.token
            }
        );

    };

    const getExtendedEligibleTeamOfficials = options => {

        return ajax(
            getUrl( options.context, 'ExtendedEligibleTeamOfficials' ),
            {
                gameId: options.gameId,
                teamId: options.teamId,
                token:  options.token
            }
        );

    };

    const getGameReportRefere = options => {

        return ajax(
            getUrl( options.context, 'GameReportReferee' ),
            {
                gameId: options.gameId,
                token:  options.token
            }
        );

    };

    const getGames = options => {

        return ajax(
            getUrl( options.context, 'Games' ),
            {
                seasonId: options.seasonId,
                token:    options.token
            }
        );

    };

    const getPlayers = options => {

        return ajax(
            getUrl( options.context, 'GetEligiblePlayers' ),
            {
                teamId: options.teamId,
                token:  options.token
            }
        );

    };

    const getReferees = options => {

        return ajax(
            getUrl( options.context, 'Referees' ),
            {
                gameId: options.gameId,
                token:  options.token
            }
        );

    };

    const getRosters = options => {

        return ajax(
            getUrl( options.context, 'Rosters' ),
            {
                gameId: options.gameId,
                token:  options.token
            }
        );

    };

    const getScores = options => {

        return ajax(
            getUrl( options.context, 'Scores' ),
            {
                gameId: options.gameId
            }
        );

    };

    const getSeasons = options => {

        return ajax(
            getUrl( options.context, 'Seasons' ),
            {
                token: options.token
            }
        );

    };

    const login = options => {

        return ajax(
            getUrl( options.context, 'Login' ),
            {
                username: options.username,
                password: options.password
            },
            {
                method: 'POST'
            }
        );

    };

    const logout = options => {

        return ajax(
            getUrl( options.context, 'Logout' ),
            {
                token: options.token
            },
            {
                method: 'POST'
            }
        );

    };

    const overwriteGameReportReferee = options => {

        return ajax(
            getUrl( options.context, 'OverwriteGameReportReferee' ),
            {
                gameId:     options.gameId,
                reportJson: JSON.stringify( options.gameReportReferee ),
                token:      options.token
            },
            {
                method: 'POST'
            }
        );

    };


    const publishRoster = options => {

        return ajax(
            getUrl( options.context, 'PublishRoster' ),
            {
                gameId:  options.gameId,
                publish: options.publish,
                teamId:  options.teamId,
                token:   options.token
            },
            {
                method: 'POST'
            }
        );

    };

    const removeRosterPlayer = options => {

        const data = {
            gameId:         options.gameId,
            playerId:       options.playerId,
            token:          options.token
        };

        if ( supports( options.context, 'teamOfficials' ) ) {

            data.isTeamOfficial = options.isTeamOfficial;

        }

        return ajax(
            getUrl( options.context, 'RemovePlayerFromRoster' ),
            data,
            {
                method: 'POST'
            }
        );

    };

    const resetPassword = options => {

        return ajax(
            getUrl( options.context, 'SetPassword' ),
            {
                token:    options.token,
                password: options.password
            },
            {
                method: 'POST'
            }
        );

    };

    const saveGameReportRefereeDraft = options => {

        return ajax(
            getUrl( options.context, 'SaveGameReportReferee' ),
            {
                gameId:     options.gameId,
                reportJson: JSON.stringify( options.gameReportReferee ),
                token:      options.token
            },
            {
                method: 'POST'
            }
        );

    };

    const sendPasswordRecovery = options => {

        return ajax(
            getUrl( options.context, 'RequestPasswordRecovery' ),
            {
                username: options.username
            },
            {
                method: 'POST'
            }
        );

    };

    const setRosterStatus = options => {

        return ajax(
            getUrl( options.context, 'SetRosterStatus' ),
            {
                gameId:  options.gameId,
                command: options.command,
                token:   options.token
            },
            {
                method: 'POST'
            }
        );

    };

    const signGameReportReferee = options => {

        return ajax(
            getUrl( options.context, 'ConfirmGameReportByTeam' ),
            {
                gameId:   options.gameId,
                token:    options.token,
                comment:  options.comment,
                username: options.name
            },
            {
                method: 'POST'
            }
        );

    }

    const signSupplementary = options => {

        return ajax(
            getUrl( options.context, 'AcceptSupplementary' ),
            {
                gameId: options.gameId,
                teamId: options.teamId,
                token:  options.token
            },
            {
                method: 'POST'
            }
        );

    };

    const takeFaceCheck = options => {

        return ajax(
            getUrl( options.context, 'LockTeam' ),
            {
                gameId: options.gameId,
                teamId: options.teamId,
                token:  options.token
            },
            {
                method: 'POST'
            }
        );

    };

    return {
        addPlayersToRoster,
        confirmGameReportReferee,
        confirmRosterPlayers,
        editRosterPlayer,
        editRosterPlayers,
        getEligiblePlayers,
        getEligibleTeamOfficials,
        getExtendedEligiblePlayers,
        getExtendedEligibleTeamOfficials,
        getGameReportRefere,
        getGames,
        getPlayers,
        getReferees,
        getRosters,
        getScores,
        getSeasons,
        login,
        logout,
        overwriteGameReportReferee,
        publishRoster,
        removeRosterPlayer,
        resetPassword,
        saveGameReportRefereeDraft,
        sendPasswordRecovery,
        setRosterStatus,
        signGameReportReferee,
        signSupplementary,
        takeFaceCheck
    };

};

export default Api();